export default __webpack_public_path__ + "477ce68f9fa4c0332827747b3d615122.svg";